<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_preview" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>Preview ({{ currentIndex + 1 }}/{{ files.length }}) <span style="margin-left:20px;">{{ cur.name }}</span></span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content" v-if="show">
                <!-- 加载中 -->
                <div class="lite-preview-loading" v-show="fullscreenLoading"></div>
                <!-- 图片预览 -->
                <img v-if="isImage && sizeOKForImage" :src="previewUrl" class="preview_img" />
                <!-- 音频预览 -->
                <audio v-else-if="isAudio" :src="previewUrl" controls class="preview_audio"></audio>
                <!-- 视频预览 -->
                <video v-else-if="isVideo" :src="previewUrl" controls class="preview_video"></video>
                <!-- 文本预览 -->
                <pre v-else-if="isText && sizeOKForText" class="preview_text">{{ textContent }}</pre>
                <!-- 无法预览，显示属性 -->
                <div v-else class="preview_info">
                    <img src="../../assets/images/workspace/un_preview.png" draggable="false">
                    <div v-if="cur.dir"><b>{{ cur.name }}</b></div>
                    <div v-else>{{ cur.name }}<span v-if="cur.size"> - {{ formatBytes(cur.size) }}</span></div>
                    <div>{{ formatDate(cur.time) }}</div>
                    <div>{{$t('language.preview.fileNotReview')}}</div>
                </div>
            </div>
            <!-- 底部 -->
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="prev()" :disabled="currentIndex==0">Prev</button>
                <button @click="next()" :disabled="currentIndex+1==files.length">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";

export default {
    props: {
        files: Array,
    },
    data() {
        return {
            show: false,
            currentIndex: 0,
            previewUrl: '',
            textContent: '',
            fullscreenLoading: false,
        };
    },
    computed: {
        cur() {
            return this.files[this.currentIndex] || {};
        },
        ext() {
            return this.cur.name ? this.cur.name.split('.').pop().toLowerCase() : '';
        },
        isImage() {
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(this.ext);
        },
        isAudio() {
            return ['mp3', 'wav', 'ogg', 'aac'].includes(this.ext);
        },
        isVideo() {
            return ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp'].includes(this.ext);
        },
        isText() {
            return ['txt', 'log', 'json', 'md', 'xml', 'yml', 'html', 'css', 'js', 'ini', 'java', 'py', 'sql'].includes(this.ext);
        },
        sizeOKForImage() {
            return this.cur.size < 10 * 1024 * 1024;
        },
        sizeOKForText() {
            return this.cur.size < 1 * 1024 * 1024;
        }
    },
    watch: {
        currentIndex() {
            this.loadPreview();
        },
        show(v) {
            if (v) this.loadPreview();
        }
    },
    methods: {
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '';
            if (value === 0) return '0Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            const num = value / Math.pow(k, i);
            return Number.isInteger(num) 
                ? num + sizes[i] 
                : num.toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            return commonUtils.i18nDateFormat(value, this.$i18n.locale);
        },
        close() {
            this.show = false;
        },
        prev() {
            if (this.currentIndex > 0) this.currentIndex--;
        },
        next() {
            if (this.currentIndex < this.files.length - 1) this.currentIndex++;
        },
        async loadPreview() {
            this.previewUrl = '';
            this.textContent = '';
            if (!this.cur || this.cur.dir) return;
            try {
                this.fullscreenLoading = true;
                const url = await this.getDownLoadUrl(this.cur);
                this.previewUrl = url;
                // 文本文件读取
                if (this.isText && this.sizeOKForText) {
                    const res = await fetch(url);
                    this.textContent = await res.text();
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.fullscreenLoading = false;
            }
        },
        async getDownLoadUrl(node) {
            const uuid = await this.prepareDownload(node);
            return `${commonstate.liteUrl}/lite/file/downloadFile?uuid=${uuid}`;
        },
        prepareDownload(node) {
            return new Promise((resolve) => {
                this.sendRequest(
                    "/file/download",
                    {
                        id: this.$store.state.curDriveId,
                        param: { node },
                    },
                    (data) => resolve(data)
                );
            });
        },
        sendRequest(path, data, callback) {
            requestUtils.doLiteRequest(path, data).then(
                (res) => {
                    let code = res.code;
                    let msg = res.msg || res.message;
                    if (code === 200) {
                        callback && callback(res.data);
                    } else if (code === 400) {
                        Message.warning(msg);
                    } else {
                        Message.error(msg);
                    }
                },
                (err) => Message.error(err)
            );
        },
    }
};
</script>

<style scoped>
/* 弹窗宽度 */
.lite_popup_box {
    width: 1300px;
    height: 800px;
}

/* 弹窗内容高度 */
.lite_preview .lite_popup_content {
    height: calc(100% - 150px);
    text-align: center;
    position: relative;
}

/* 按钮布局 */
.lite_popup_footer {
    text-align: center;
}

.preview_img, .preview_video, .preview_audio {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
}
.preview_text {
    text-align: left;
    white-space: pre-wrap;
    overflow: auto;
    height: 100%;
}

.preview_info {
    margin: 180px 300px;
    text-align: center;
    border-radius: 4px;
}

.preview_info>div {
    margin-top: 5px;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #6f7886;
}

video {
    background-color: #000;
}

/* 加载中 */
.lite-preview-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 简洁圆环旋转动画 */
.lite-preview-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_preview.vue